module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_1@2x.7fc872bc.png";